<template>
  <el-dialog v-bind="$attrs"
             v-on="$listeners"
             append-to-body
             :before-close="handleClose">
    <div class="md:px-3 widget-job-apply_modal__wrapper">
      <el-form :model="form" ref="form" label-position="top" :rules="validationRules" class="widget-job-apply_modal">
        <div class="flex flex-col sm:flex-row justify-between widget-job-apply_modal-first_section__wrapper">
          <div class="w-full sm:pr-2 widget-job-apply_modal-email-name">
            <base-input :label="this.$t('common.email')" prop="email" v-model="form.email"/>
            <base-input class="mt-10" :label="this.$t('common.givenName')" prop="given_name" v-model="form.given_name"/>
          </div>
          <div class="w-full sm:pl-2 widget-job-apply_modal-salutation-family">
            <base-radio class="mt-4 mb-20 sm:mt-0" prop="salutation" :label="this.$t('common.salutation')"
                        v-model="form.salutation"
                        :radio-options="radioOptionsSalutation"/>
            <base-input class="sm:mt-10" :label="this.$t('common.familyName')" prop="family_name"
                        v-model="form.family_name"/>
          </div>
        </div>
        <phone-input class="mt-6 widget-job-apply_modal-phone-input__wrapper"
                     prop="phone"
                     :label="this.$t('common.phoneNumber')"
                     :value="form.phone"
                     @input-data="onPhoneChange"/>
        <base-radio class="mt-4 mb-16 sm:mt-10 widget-job-apply_modal-motivation__wrapper" prop="salutation" :label="this.$t('common.motivationType')"
                    v-model="motivationType"
                    :radio-options="radioOptionsMotivation"/>
        <base-input v-if="motivationType === 'text'" class="mt-10 widget-job-apply_modal-motivation_field" type="textarea"
                    :label="this.$t('common.motivation')" prop="motivation_text"
                    v-model="form.motivation_text"/>
        <upload v-else
                class="mt-12 widget-job-apply_modal-upload_motivation__wrapper"
                prop="motivationToken"
                :label="this.$t('common.uploadMotivation').toUpperCase()"
                v-model="form.motivationToken"
                ref="motivationUpload"
                :upload-params="{id: job.uuid}"/>
        <upload class="mt-8 widget-job-apply_modal-upload_cv__wrapper"
                prop="cvToken"
                :label="this.$t('common.uploadCV').toUpperCase()"
                v-model="form.cvToken"
                ref="aUpload"
                :upload-params="{id: job.uuid}"/>
        <div class="flex flex-col mt-8 widget-job-apply_modal-terms-accepted__wrapper">
          <el-form-item class="mb-6 widget-job-apply_modal-terms-accept_item" prop="termsAccepted">
            <el-checkbox-group v-model="form.termsAccepted">
              <el-checkbox label="true"
                           name="termsAccepted">
                <div class="text-gray-700"><span class="text-red-400">* </span>{{$t('common.readAndAcceptTerms')}}</div>
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-checkbox class="mb-6 widget-job-apply_modal-newsletter_item" v-for="item in candidateNewsletters"
                       :key="item.id"
                       v-model="form.newsletters[item.id]">
            <div class="font-light text-gray-700">{{item.opt_in_message}}</div>
          </el-checkbox>
        </div>
      </el-form>
      <div v-if="generalTerms || privacyTerms"
           v-html="termsText"
           class="card__text-preview mb-6 widget-job-apply_modal-terms_field"/>
      <div class="flex flex-row justify-end widget-job-apply_modal_action-buttons__wrapper">
        <el-button class="cancel-button widget-job-apply_modal_action-button_cancel" @click="closeModal">{{$t('common.cancel')}}</el-button>
        <el-button class="widget-job-apply_modal_action-buttons_confirm" @click="confirmApply">{{$t('common.confirm')}}</el-button>
      </div>
    </div>

  </el-dialog>
</template>

<script>
  import BaseInput from '../inputs/BaseInput'
  import BaseRadio from '../inputs/BaseRadio'
  import PhoneInput from '../inputs/PhoneInput'
  import { isValidNumber } from 'libphonenumber-js'
  import Upload from '../inputs/Upload'
  import { applyForJob } from '../../API/job'
  import { Notification, MessageBox, CheckboxGroup } from 'element-ui'
  import { TRACKING_EVENTS } from '../../enum/tracking'

  export default {
    name: 'apply-modal',
    components: {
      PhoneInput,
      BaseRadio,
      BaseInput,
      Upload,
      'el-checkbox-group': CheckboxGroup,
    },
    props: {
      job: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      termsAndConditions() {
        return this.$store.getters['getTermsAndConditions']
      },
      generalTerms() {
        return this.termsAndConditions.app_terms || ''
      },
      privacyTerms() {
        return this.termsAndConditions.app_privacy || ''
      },
      termsText() {
        return this.generalTerms + '<br>' + this.privacyTerms || 'General terms and conditions'
      },
      candidateNewsletters() {
        return this.$store.getters['getNewsletters']
      },
      validationRules() {
        let validatePhone = (rule, value, callback) => {
          let validPhone = isValidNumber(value)
          if (!validPhone) {
            callback(new Error('Phone number is invalid'))
          } else {
            callback()
          }
        }

        return {
          email: [
            { required: true, message: this.$t('jobApply.emailRequired'), trigger: 'blur' },
            { type: 'email', message: this.$t('jobApply.validEmail'), trigger: 'blur' }
          ],
          given_name: [
            { required: true, message: this.$t('jobApply.nameRequired'), trigger: 'blur' }
          ],
          family_name: [
            { required: true, message: this.$t('jobApply.familyRequired'), trigger: 'blur' }
          ],
          salutation: [
            { required: true, message: this.$t('jobApply.salutationRequired'), trigger: 'change' }
          ],
          phone: [
            { required: true, message: this.$t('jobApply.phoneRequired'), trigger: 'blur' },
            { validator: validatePhone, trigger: 'blur' }
          ],
          motivation_text: [
            { required: true, message: this.$t('jobApply.motivationRequired'), trigger: 'blur' }
          ],
          cvToken: [
            { required: true, message: this.$t('jobApply.CVRequired'), trigger: 'change' }
          ],
          motivationToken: [
            { required: true, message: this.$t('jobApply.motivationFileRequired'), trigger: 'change' }
          ],
          termsAccepted: [
            { type: 'array', required: true, message: this.$t('jobApply.checkboxRequired'), trigger: 'change' }
          ]
        }
      }
    },
    data() {
      return {
        form: this.initFormData(),
        motivationType: 'text',
        radioOptionsSalutation: [{
          value: 'mr',
          label: 'Mr',
        }, {
          value: 'miss',
          label: 'Miss',
        }],
        radioOptionsMotivation: [{
          value: 'text',
          label: 'Text',
        }, {
          value: 'file',
          label: 'File',
        }]
      }
    },
    methods: {
      initFormData() {
        return {
          email: '',
          given_name: '',
          salutation: 'mr',
          motivation: 'text',
          family_name: '',
          phone: '+31',
          phone_country: 'NL',
          motivation_text: '',
          cvToken: null,
          motivationToken: null,
          newsletters: [],
          termsAccepted: []
        }
      },
      onPhoneChange(data) {
        this.form.phone = data.number
        this.form.phone_country = data.activeCountry.iso2
      },
      closeModal() {
        this.form = this.initFormData()
        this.$emit('closeModal')
      },
      getNewsletters() {
        if (this.form.newsletters.length > 0) {
          return Object.keys(this.form.newsletters).filter(key => this.form.newsletters[key]).map(key => +key)
        }
      },
      async confirmApply() {
        try {
          await this.$refs.form.validate()
          const jobBoardId = 1;
          const newsletters = this.getNewsletters()
          const motivation_text = this.motivationType === 'text' ? this.form.motivation_text : null
          const motivation = this.motivationType !== 'text' ? this.form.motivationToken : null
          const formData = { ...this.form, newsletters, motivation_text, motivation }
          await applyForJob(formData, this.job, jobBoardId)
          this.closeModal()
          this.$refs.form.resetFields()
          this.resetUploadFields()
          this.$analytics(TRACKING_EVENTS.JOB_APPLY_FINISH, {
            job: this.job,
            eventLabel: this.job.uuid
          })

          Notification.success({ message: 'Your application was successful!' })
        } catch (e) {
          console.log(e)
        }
      },
      handleClose(done) {
        if (JSON.stringify(this.form) === JSON.stringify(this.initFormData())) {
          this.$emit('closeModal')
          return
        }
        MessageBox.confirm('Are you sure to close this dialog? All form data will be lost.', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          cancelButtonClass: 'cancel-button'
        })
        // eslint-disable-next-line no-unused-vars
          .then(_ => {
            this.$refs.form.clearValidate()
            this.$refs.form.resetFields()
            this.form = this.initFormData()
            this.resetUploadFields()
            done()
          })
          // eslint-disable-next-line no-unused-vars
          .catch(_ => {})
      },
      resetUploadFields() {
        if (this.$refs.aUpload) {
          this.$refs.aUpload.reset()
        }
        if (this.$refs.motivationUpload) {
          this.$refs.motivationUpload.reset()
        }
      }
    }
  }
</script>
